// Please don't change this map without consulting with the AMEX UCM team first.
// This map was provided by the AMEX UCM team and is used to determine which markets require the consent market logic.
const ucmCountryCodes = {
  AD: 'en-AD',
  AE: 'en-AE',
  AF: 'en-AF',
  AG: 'en-AG',
  AI: 'en-AI',
  AL: 'en-AL',
  AM: 'en-AM',
  AO: 'en-AO',
  AQ: 'en-AQ',
  AR: 'en-AR',
  AS: 'en-AS',
  AT: 'de-AT',
  AU: 'en-AU',
  AW: 'en-AW',
  AX: 'en-AX',
  AZ: 'en-AZ',
  BA: 'en-BA',
  BB: 'en-BB',
  BD: 'en-BD',
  BE: 'fr-BE',
  BF: 'en-BF',
  BH: 'en-BH',
  BI: 'en-BI',
  BJ: 'en-BJ',
  BL: 'en-BL',
  BM: 'en-BM',
  BN: 'en-BN',
  BO: 'en-BO',
  BQ: 'en-BQ',
  BR: 'en-BR',
  BS: 'en-BS',
  BT: 'en-BT',
  BV: 'en-BV',
  BW: 'en-BW',
  BY: 'en-BY',
  BZ: 'en-BZ',
  CA: 'en-CA',
  CC: 'en-CC',
  CD: 'en-CD',
  CF: 'en-CF',
  CG: 'en-CG',
  CH: 'en-CH',
  CI: 'en-CI',
  CK: 'en-CK',
  CL: 'en-CL',
  CM: 'en-CM',
  CN: 'en-CN',
  CO: 'en-CO',
  CR: 'en-CR',
  CU: 'en-CU',
  CV: 'en-CV',
  CW: 'en-CW',
  CX: 'en-CX',
  CZ: 'cs-CZ',
  DE: 'de-DE',
  DJ: 'en-DJ',
  DK: 'da-DK',
  DM: 'en-DM',
  DO: 'en-DO',
  DZ: 'en-DZ',
  EC: 'en-EC',
  EG: 'en-EG',
  EH: 'en-EH',
  EI: 'en-EI',
  ER: 'en-ER',
  ES: 'es-ES',
  ET: 'en-ET',
  EU: 'en-EU',
  FI: 'fi-FI',
  FJ: 'en-FJ',
  FK: 'en-FK',
  FM: 'en-FM',
  FO: 'en-FO',
  FR: 'fr-FR',
  GA: 'en-GA',
  GB: 'en-GB',
  GD: 'en-GD',
  GE: 'en-GE',
  GF: 'en-GF',
  GG: 'en-GG',
  GH: 'en-GH',
  GI: 'en-GI',
  GL: 'en-GL',
  GM: 'en-GM',
  GN: 'en-GN',
  GP: 'en-GP',
  GQ: 'en-GQ',
  GS: 'en-GS',
  GT: 'en-GT',
  GU: 'en-GU',
  GW: 'en-GW',
  GY: 'en-GY',
  HK: 'en-HK',
  HM: 'en-HM',
  HN: 'en-HN',
  HT: 'en-HT',
  HU: 'hu-HU',
  ICC: 'en-ICC',
  ID: 'en-ID',
  IE: 'en-IE',
  IL: 'en-IL',
  IM: 'en-IM',
  IN: 'en-IN',
  IO: 'en-IO',
  IQ: 'en-IQ',
  IR: 'en-IR',
  IT: 'it-IT',
  JE: 'en-JE',
  JM: 'en-JM',
  JO: 'en-JO',
  JP: 'en-JP',
  KE: 'en-KE',
  KG: 'en-KG',
  KH: 'en-KH',
  KI: 'en-KI',
  KM: 'en-KM',
  KN: 'en-KN',
  KP: 'en-KP',
  KR: 'en-KR',
  KW: 'en-KW',
  KY: 'en-KY',
  KZ: 'en-KZ',
  LA: 'en-LA',
  LB: 'en-LB',
  LC: 'en-LC',
  LK: 'en-LK',
  LR: 'en-LR',
  LS: 'en-LS',
  LY: 'en-LY',
  MA: 'en-MA',
  MC: 'en-MC',
  MD: 'en-MD',
  ME: 'en-ME',
  MF: 'en-MF',
  MG: 'en-MG',
  MH: 'en-MH',
  MK: 'en-MK',
  ML: 'en-ML',
  MM: 'en-MM',
  MN: 'en-MN',
  MO: 'en-MO',
  MP: 'en-MP',
  MQ: 'en-MQ',
  MR: 'en-MR',
  MS: 'en-MS',
  MU: 'en-MU',
  MV: 'en-MV',
  MW: 'en-MW',
  MX: 'en-MX',
  MY: 'en-MY',
  MZ: 'en-MZ',
  NA: 'en-NA',
  NC: 'en-NC',
  NE: 'en-NE',
  NF: 'en-NF',
  NG: 'en-NG',
  NI: 'en-NI',
  NL: 'nl-NL',
  NO: 'nb-NO',
  NP: 'en-NP',
  NR: 'en-NR',
  NU: 'en-NU',
  NZ: 'en-NZ',
  OM: 'en-OM',
  PA: 'en-PA',
  PE: 'en-PE',
  PF: 'en-PF',
  PG: 'en-PG',
  PH: 'en-PH',
  PK: 'en-PK',
  PL: 'pl-PL',
  PM: 'en-PM',
  PN: 'en-PN',
  PR: 'en-PR',
  PS: 'en-PS',
  PW: 'en-PW',
  PY: 'en-PY',
  QA: 'en-QA',
  RE: 'en-RE',
  RS: 'en-RS',
  RU: 'en-RU',
  RW: 'en-RW',
  SA: 'en-SA',
  SB: 'en-SB',
  SC: 'en-SC',
  SD: 'en-SD',
  SE: 'sv-SE',
  SG: 'en-SG',
  SH: 'en-SH',
  SJ: 'en-SJ',
  SL: 'en-SL',
  SM: 'en-SM',
  SN: 'en-SN',
  SO: 'en-SO',
  SR: 'en-SR',
  SS: 'en-SS',
  ST: 'en-ST',
  SV: 'en-SV',
  SX: 'en-SX',
  SY: 'en-SY',
  SZ: 'en-SZ',
  TC: 'en-TC',
  TD: 'en-TD',
  TF: 'en-TF',
  TG: 'en-TG',
  TH: 'en-TH',
  TJ: 'en-TJ',
  TK: 'en-TK',
  TL: 'en-TL',
  TM: 'en-TM',
  TN: 'en-TN',
  TO: 'en-TO',
  TR: 'en-TR',
  TT: 'en-TT',
  TV: 'en-TV',
  TW: 'en-TW',
  TZ: 'en-TZ',
  UA: 'en-UA',
  UG: 'en-UG',
  UM: 'en-UM',
  US: 'en-US',
  UY: 'en-UY',
  UZ: 'en-UZ',
  VA: 'en-VA',
  VC: 'en-VC',
  VE: 'en-VE',
  VG: 'en-VG',
  VI: 'en-VI',
  VN: 'en-VN',
  VU: 'en-VU',
  WF: 'en-WF',
  WS: 'en-WS',
  XA: 'en-XA',
  XB: 'en-XB',
  YE: 'en-YE',
  YT: 'en-YT',
  ZA: 'en-ZA',
  ZM: 'en-ZM',
  ZW: 'en-ZW',
};

export default ucmCountryCodes;
